import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';

// Embeds the demo video in a QuByt-branded frame instead of sending
// people to youtube.com. Swap YOUTUBE_ID below to change the video.
const YOUTUBE_ID = 'sQCLUqSoZp4';
const EMBED_SRC = `https://www.youtube-nocookie.com/embed/${YOUTUBE_ID}?autoplay=1&rel=0&modestbranding=1`;

const VideoModal = ({ onClose, onGetStarted }) => {
  const overlayRef = useRef(null);
  const dialogRef = useRef(null);

  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    dialogRef.current?.focus();
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) onClose();
  };

  return (
    <div
      className="video-modal-overlay"
      ref={overlayRef}
      onClick={handleOverlayClick}
      role="presentation"
    >
      <div
        className="video-modal"
        role="dialog"
        aria-modal="true"
        aria-label="QuByt AI demo video"
        ref={dialogRef}
        tabIndex={-1}
      >
        <button className="video-modal-close" onClick={onClose} aria-label="Close demo">
          <X size={20} />
        </button>

        <div className="video-modal-header">
          <span className="video-modal-eyebrow">QuByt AI</span>
          <h3 className="video-modal-title">Watch the demo</h3>
        </div>

        <div className="video-modal-frame">
          <iframe
            src={EMBED_SRC}
            title="QuByt AI demo video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>

        <div className="video-modal-footer">
          <button
            className="btn-primary video-cta-btn"
            onClick={() => {
              onClose();
              onGetStarted?.();
            }}
          >
            Build Your First App
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
